export const methods = {
  ideal: {
    title: "iDeal / Wero",
    name: "ideal",
    isInstant: true,
    description: "Default Dutch online payment method.",
    requirement: "",
  },
  invoice: {
    title: "Bank transfer",
    name: "invoice",
    description: "Invoice by e-mail, order is completed once we've received payment.",
    requirement:
      "Your limit of unpaid invoices on bank transfer is exceeded with this order. Please select another method or pay your invoices {alink}. For questions about your limit, {acontact}.",
  },
  card: {
    title: "Credit card",
    name: "card",
    fee: "2.95%",
    isInstant: true,
    description: "Visa, Mastercard and American Express.",

    requirement: "Only available for transactions under 20.000 EUR",
  },
  apple_pay: {
    title: "Apple Pay",
    name: "apple_pay",
    fee: "2.95%",
    isInstant: true,
    description: "Pay with Apple",
    requirement: "",
  },
  pay_by_30days: {
    title: "Pay 30 days later",
    name: "pay_by_30days",
    fee: "0.95%",
    isInstant: true,
    description: "Invoice by e-mail, will have to be paid within 30 days by bank transfer.",

    requirement: "Exceeded the total limit for this payment method.",
  },
  pay_by_60days: {
    title: "Pay 60 days later",
    name: "pay_by_60days",
    fee: "2.10%",
    isInstant: true,
    description: "Invoice by e-mail, will have to be paid within 60 days by bank transfer.",

    requirement: "Exceeded the total limit for this payment method.",
  },
  pay_by_90days: {
    title: "Pay 90 days later",
    name: "pay_by_90days",
    fee: "3.10%",
    isInstant: true,
    description: "Invoice by e-mail, will have to be paid within 90 days by bank transfer.",

    requirement: "Exceeded the total limit for this payment method.",
  },

  pay_by_180days: {
    title: "Pay 180 days later",
    name: "pay_by_180days",
    fee: "6.56%",
    isInstant: true,
    description: "Invoice by e-mail, will have to be paid within 180 days by bank transfer.",

    requirement: "Exceeded the total limit for this payment method.",
  },
};
